import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-shipping',
  templateUrl: './pda-shipping.component.html',
  styleUrls: ['./pda-shipping.component.scss']
})
export class PdaShippingComponent implements OnInit {

  constructor(
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/shipping/pda-shipping.component.ts